/*
  Regnr-cache for bilfilteret (year-make-model.js), 25.10.2026
  - Nytt navn paa lageret (regLookup2:), saa svar lagret foer kjoeretoytype-tabellen ble tatt i bruk ignoreres
  - Kortere levetid: 1 dag naar bilen ble funnet, 10 minutter ellers (var 7 dager og 1 time)
  - Gamle svar (regLookup:) ryddes bort en gang per nettleser
  Lastes etter year-make-model.js og endrer bare de to cache-funksjonene.
*/
(function () {
  var NEW_PREFIX = 'regLookup2:';
  var TTL_FULL = 1000 * 60 * 60 * 24;
  var TTL_OTHER = 1000 * 60 * 10;

  function newKey(key) {
    return String(key || '').replace(/^regLookup:/, NEW_PREFIX);
  }

  function cleanupOld() {
    try {
      if (localStorage.getItem('sbRegCacheV2')) return;
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf('regLookup:') === 0) localStorage.removeItem(k);
      }
      localStorage.setItem('sbRegCacheV2', '1');
    } catch (e) {}
  }

  function patch() {
    var inst = window._pfInstance;
    if (!inst) return false;
    var proto = Object.getPrototypeOf(inst);
    if (!proto || typeof proto.getCachedRegistration !== 'function') return false;
    if (proto._sbRegCachePatched) return true;

    var origGet = proto.getCachedRegistration;
    proto.getCachedRegistration = function (cacheKey) {
      return origGet.call(this, newKey(cacheKey));
    };

    proto.cacheRegistration = function (cacheKey, data) {
      try {
        var key = newKey(cacheKey);
        var isStrong = !!(data && data.status === true && data.brand_name && data.model_name && data.year);
        localStorage.setItem(key, JSON.stringify({ data: data, expiresAt: Date.now() + (isStrong ? TTL_FULL : TTL_OTHER) }));
        if (typeof this._addToRegIndex === 'function') this._addToRegIndex(key);
        if (typeof this._evictOldRegEntries === 'function') this._evictOldRegEntries();
      } catch (e) {}
    };

    proto._sbRegCachePatched = true;
    cleanupOld();
    return true;
  }

  if (!patch()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!patch()) setTimeout(patch, 500);
    });
  }
})();
